export { default as PreferencePage } from './preference-page';
